export const addInvitee = () => ({ type: 'add-invitee' })
export const updateInvitee = (index, invitee) => ({ type: 'update-invitee', index: index, invitee: invitee })
export const removeInvitee = (index) => ({ type: 'remove-invitee', index: index })